const errorCodes = {
  '03': 'Accepteur invalide',
  '05': 'Ne pas honorer',
  '12': 'Transaction Invalide',
  '14': 'Numéro de Porteur Invalide',
  '30': 'Erreur de format',
  '51': 'Provision insuffisante ou crédit dépassé',
  '54': 'Date de validité de la carte dépassée',
  '56': 'Carte absente du fichier',
  '57': 'Transaction non permise à ce porteur',
  '59': 'Suspicion de fraude',
  '60': 'L’accepteur de carte doit contacter l’acquéreur',
  '61': 'Montant supérieur au plafond autorisé',
  '81': 'A1 Refus Soft Decline',
  'IDENTIFIER_EXPIRED': 'Carte expirée, enregistre une nouvelle carte',

};

export function getErrorMessage(code) {
  return errorCodes[code?.toString()] || "Code d'erreur inconnu";
}

export const errorMessages = {
  'token creation failed.': 'Enregistrement de carte refusé par la banque. Vérifie tes plafonds ou contacte ta banque.',
  'Token creation failed.': 'Enregistrement de carte refusé par la banque. Vérifie tes plafonds ou contacte ta banque.'
}
